module.exports = __webpack_public_path__ + "media/images/alert_icon-8f923340ccbd81ef3e2e22728357c7f8.svg";